import { paramsService } from "../../api/params";

export const GET_DATA = "GET_PARAMS";
export const ADD = "ADD_PARAM";
export const UPDATE = "UPDATE_PARAM";
export const DELETE = "DELETE_PARAM";
export const SET_INITIALIZED_DATA = "SET_INITIALIZED_DATA_PARAMS";
export const ADD_SELECTED_ROW = "ADD_SELECTED_ROW_PARAM";
export const DELETE_SELECTED_ROW = "DELETE_SELECTED_ROW_PARAM";
export const SET_SELECTED_ROWS = "SET_SELECTED_ROWS_PARAM";
export const SET_FILTERS = "SET_FILTERS_PARAMS";
export const SET_SORTERS = "SET_SORTERS_PARAMS";

export function getData() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      paramsService.getData().then(
        (response) => {
          dispatch({ type: GET_DATA, payload: response });
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function get(code) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      paramsService.get(code).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function add(form) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      paramsService.add(form).then(
        (response) => {
          dispatch({ type: ADD, payload: response });
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function update(code, form) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      paramsService.update(code, form).then(
        (response) => {
          dispatch({ type: UPDATE, code, payload: response });
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function remove(code) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      paramsService.delete(code).then(
        (response) => {
          dispatch({ type: DELETE, code, payload: response });
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function setInitializedData(value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: SET_INITIALIZED_DATA, payload: value });
      resolve();
    });
  };
}

export function addSelectedRow(record) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: ADD_SELECTED_ROW, payload: record });
      resolve();
    });
  };
}

export function removeSelectedRow(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: DELETE_SELECTED_ROW, id });
      resolve();
    });
  };
}

export function setSelectedRows(records) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: SET_SELECTED_ROWS, payload: records });
      resolve();
    });
  };
}

export function setFilters(value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: SET_FILTERS, payload: value });
      resolve();
    });
  };
}

export function setSorters(value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: SET_SORTERS, payload: value });
      resolve();
    });
  };
}
